import { ApolloClient /*, createHttpLink */, createHttpLink, InMemoryCache } from '@apollo/client/core'
import fetch from 'cross-fetch'
import { DefaultApolloClient } from '@vue/apollo-composable'
import { boot } from 'quasar/wrappers'
let apolloClient

import { setContext } from 'apollo-link-context'
import jwtDecode from 'jwt-decode'

export default boot(
  ({ app }) => {
    const getClientOptions = () => {
      const authLink = setContext((_, { headers }) => {
        const isBrowser = typeof window !== 'undefined'
        let accessToken
        let refreshToken
        if (isBrowser) {
          accessToken = localStorage.getItem('accessToken')
          refreshToken = localStorage.getItem('refreshToken')
        }
        if (refreshToken) {
          const decoded = jwtDecode(refreshToken)
          const d = new Date(0)
          d.setUTCSeconds(decoded.exp)
        }
        if (accessToken) {
          return {
            headers: {
              ...headers,
              authorization: `Bearer ${accessToken}`
            }
          }
        }
        return {
          headers
        }
      })
      const httpLink = createHttpLink({
        uri: process.env.API_HTTP,
        fetch: fetch
      })
      return Object.assign(
        {
          link: authLink.concat(httpLink),
          cache: new InMemoryCache()
        },
        process.env.MODE === 'spa'
          ? {
            //
            }
          : {},
        process.env.MODE === 'ssr'
          ? {
            //
            }
          : {},
        process.env.MODE === 'pwa'
          ? {
            //
            }
          : {},
        process.env.MODE === 'bex'
          ? {
            //
            }
          : {},
        process.env.MODE === 'cordova'
          ? {
            //
            }
          : {},
        process.env.MODE === 'capacitor'
          ? {
            //
            }
          : {},
        process.env.MODE === 'electron'
          ? {
            //
            }
          : {},
        // dev/prod options.
        process.env.DEV
          ? {
            //
            }
          : {},
        process.env.PROD
          ? {
            //
            }
          : {},
        // For ssr mode, when on server.
        process.env.MODE === 'ssr' && process.env.SERVER
          ? {
              ssrMode: true
            }
          : {},
        // For ssr mode, when on client.
        process.env.MODE === 'ssr' && process.env.CLIENT
          ? {
              ssrForceFetchDelay: 100
            }
          : {}
      )
    }
    apolloClient = new ApolloClient(getClientOptions())
    const apolloClients = {
      default: apolloClient
    }
    app.provide(DefaultApolloClient, apolloClients)
  }
)

export { apolloClient }
